import { useStore as useShapeStore } from '@/stores/shape';
import { useStore as useProductStore } from '@/stores/product';
import { useStore as useNotificationStore } from '@/stores/notification';
import { useStore as useMirrorStore } from '@/stores/mirror';
import cloneDeep from 'lodash.clonedeep';
import { StateSnapshot } from '@/typings';

export function createStateSnapshot(): StateSnapshot {
  const shapeStore = useShapeStore();
  const productStore = useProductStore();
  const notificationStore = useNotificationStore();
  const mirrorStore = useMirrorStore();

  const snapshot: StateSnapshot = {
    shapeState: {
      shapes: cloneDeep(shapeStore.shapes),
      activeShapeId: shapeStore.activeShapeId,
      positionShapeMap: cloneDeep(shapeStore.positionShapeMap),
    },
    productState: {
      unavailablePrintPositions: cloneDeep(
        productStore.unavailablePrintPositions
      ),
      selectedPrintPosition: cloneDeep(productStore.selectedPrintPosition),
      lastManagedPrintPositionId: productStore.lastManagedPrintPositionId,
      previousManagedPrintPositionId:
        productStore.previousManagedPrintPositionId,
    },
    notificationState: {
      notificationsForBell: cloneDeep(notificationStore.notificationsForBell),
      allValidatorPipelineResults: cloneDeep(
        notificationStore.allValidatorPipelineResults
      ),
    },
    mirrorState: {
      mirrorShapes: cloneDeep(mirrorStore.mirrorShapes),
      positionMirrorShapeMap: cloneDeep(mirrorStore.positionMirrorShapeMap),
      positionMirrorSettings: cloneDeep(mirrorStore.positionMirrorSettings),
    },
  };

  return snapshot;
}
